import React, { useEffect, useState } from "react";
import AnimateMenu from "./AnimateMenu";
import AnimateClose from "./AnimateClose";
import { Link } from "react-router-dom";
import { NavBarLinks } from "../../constants";
import "./NavBar.css";
import "./Style/Style.css";
import { NavBarLinksKids } from "../../constants/NavBarLinks";
import NavBarPhone from "./NavBarPhone";
import P5Sketch from "./particles.js";

const NavBar = ({ displayNavBar }) => {
  // Function called when link hovered On
  const handleHoverLink = (sublink) => {
    // Set the sublink to be displayed
    setSublink(sublink);
  };

  // variable that changes when clicking on NavBar
  const [toggle, setToggle] = useState(false);
  // variable that changes the set of sublinks of interest
  const [sublink, setSublink] = useState([""]);
  // variable that changes if new routing for kids is needed
  const [kids, setKids] = useState(false);
  //variable used to make sure when kids button touch the animation is not repeated for the links
  const [noAnimation, setNoAnimation] = useState(false);
  const [savior, setSavior] = useState(false);

  // resets the other variables when opening and closing navbar
  useEffect(() => {
    setSublink([""]);
    setKids(false);
    setNoAnimation(false);
  }, [toggle]);

  // when Navbar is opened or closed
  const handleClick = () => {
    setToggle(!toggle);
    setSublink([""]);
  };

  // when kids button is activated or not
  const kidsButton = () => {
    setKids(!kids);
    setSublink([""]);
    setNoAnimation(true);
  };

  return (
    <div className="relative z-10">
      {!toggle && displayNavBar && (
        //##############################################################################################
        //Display the Menu Icon
        <div
          className="md:w-[4rem] w-[3rem] h-[3rem] md:h-[4rem] fixed"
          onClick={handleClick}
        >
          {/*When NavBar is closed -> enable scrolling on body*/}
          <script>{(document.body.style.overflow = "auto")}</script>
          <AnimateMenu />
        </div>
        //##############################################################################################
      )}{" "}
      {
        //##############################################################################################
        //Display NavBar
        toggle && (
          <div>
            <div
              id="dynamic-bg"
              className="fixed z-1 h-screen bg_open_animation"
            >
              {" "}
              <P5Sketch savior={savior} setSavior={setSavior} />{" "}
            </div>
            <div className="fixed z-2 w-full h-screen grid-cols-3 bg_open_animation hidden md:grid">
              {/*Make sure that user cannot scroll when NavBar opened */}
              <script>{(document.body.style.overflow = "hidden")}</script>
              <ul className="flex flex-col justify-center mt-1 mb-10 px-[3rem] col-start-1 ">
                {(kids ? NavBarLinksKids : NavBarLinks).map((link) => {
                  return (
                    <Link to={`/${link.titleLink}`}>
                      <li
                      className={`"text-[50px] flex items-center ${
                        noAnimation ? "" : "links_animation opacity-0"
                      }`}
                    >
                      <img
                        src={link.logo}
                        alt={`${link.title} Logo`}
                        className="mr-2 w-12 aspect-w-12 hidden md:block"
                      />
                      
                      <span
                        className="highlight"
                        style={{
                          fontFamily: "Geologica_bold",
                          fontSize: "5vh",
                          color: "var(--purple-white)",
                          marginBottom: "0px",
                        }}
                        onMouseEnter={() => handleHoverLink(link.subsection)}
                      >
                        {link.title}{" "}
                      </span>
                    </li></Link>
                  );
                })}{" "}
              </ul>
              <ul className="flex flex-col justify-center items-center col-start-2">
                {sublink.map((n) => {
                  return (
                    <li className="mb-0">
                      <Link
                        className="text-[35px] gap-10 sub "
                        style={{
                          fontFamily: "Geologica_bold",
                          fontSize: "4.5vh",
                          color: "var(--purple-white)",
                        }}
                        to={`/${n.url}`}
                        onClick={handleClick}
                      >
                        {n.section}{" "}
                      </Link>
                    </li>
                  );
                })}{" "}
              </ul>
              <div className="flex col-start-3 flex-col items-center justify-between h-full gap-10">
                <div className="w-[9vw] h-[9vw]" onClick={handleClick}>
                  <AnimateClose />
                </div>

                <div
                  className="logo_animation opacity-0 flex items-center flex-col"
                  style={{
                    fontFamily: "Geologica_bold",
                    fontSize: "1.5vw",
                    color: "var(--purple-white)",
                    maxWidth: "150px",
                    textAlign: "center",
                  }}
                >
                  User-friendly menu
                  <input type="checkbox" id="switch" onInput={kidsButton} />
                  <label for="switch">Toggle</label>
                </div>
                <img
                  src={
                    "https://static.igem.wiki/teams/4888/wiki/48c-logo-1x.png"
                  }
                  alt="48C"
                  className="w-[9rem] h-[9rem]  logo_animation opacity-0 mb-10"
                />
              </div>
            </div>
            <NavBarPhone
              setToggle={setToggle}
              toggle={toggle}
              setNoAnimation={setNoAnimation}
              setSublink={setSublink}
              setKids={setKids}
            />
          </div>
        )
      }
    </div>
  );
};

export default NavBar;
